/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getTemplate = /* GraphQL */ `query GetTemplate($id: ID!) {
  getTemplate(id: $id) {
    id
    name
    input
    textLayers {
      name
      font
      defaultText
      __typename
    }
    textLayerName
    textLayerFont
    otherFonts
    poster
    attribution
    hidden
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTemplateQueryVariables,
  APITypes.GetTemplateQuery
>;
export const listTemplates = /* GraphQL */ `query ListTemplates(
  $filter: ModelTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  listTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      input
      textLayers {
        name
        font
        defaultText
        __typename
      }
      textLayerName
      textLayerFont
      otherFonts
      poster
      attribution
      hidden
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTemplatesQueryVariables,
  APITypes.ListTemplatesQuery
>;
export const getCampaign = /* GraphQL */ `query GetCampaign($id: ID!) {
  getCampaign(id: $id) {
    id
    userId
    templateId
    template {
      id
      name
      input
      textLayers {
        name
        font
        defaultText
        __typename
      }
      textLayerName
      textLayerFont
      otherFonts
      poster
      attribution
      hidden
      createdAt
      updatedAt
      __typename
    }
    name
    width
    customText {
      layerName
      text
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCampaignQueryVariables,
  APITypes.GetCampaignQuery
>;
export const listCampaigns = /* GraphQL */ `query ListCampaigns(
  $filter: ModelCampaignFilterInput
  $limit: Int
  $nextToken: String
) {
  listCampaigns(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userId
      templateId
      template {
        id
        name
        input
        textLayerName
        textLayerFont
        otherFonts
        poster
        attribution
        hidden
        createdAt
        updatedAt
        __typename
      }
      name
      width
      customText {
        layerName
        text
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCampaignsQueryVariables,
  APITypes.ListCampaignsQuery
>;
export const getTracking = /* GraphQL */ `query GetTracking($id: ID!) {
  getTracking(id: $id) {
    id
    userId
    templateId
    templateData
    campaignData
    text
    width
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTrackingQueryVariables,
  APITypes.GetTrackingQuery
>;
export const listTrackings = /* GraphQL */ `query ListTrackings(
  $filter: ModelTrackingFilterInput
  $limit: Int
  $nextToken: String
) {
  listTrackings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userId
      templateId
      templateData
      campaignData
      text
      width
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrackingsQueryVariables,
  APITypes.ListTrackingsQuery
>;
export const campaignsByUserId = /* GraphQL */ `query CampaignsByUserId(
  $userId: ID
  $sortDirection: ModelSortDirection
  $filter: ModelCampaignFilterInput
  $limit: Int
  $nextToken: String
) {
  campaignsByUserId(
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      templateId
      template {
        id
        name
        input
        textLayerName
        textLayerFont
        otherFonts
        poster
        attribution
        hidden
        createdAt
        updatedAt
        __typename
      }
      name
      width
      customText {
        layerName
        text
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CampaignsByUserIdQueryVariables,
  APITypes.CampaignsByUserIdQuery
>;
